<template>
  <div>
    <p>
      Sorry, your product didn't meet our terms
    </p>
    <p>
      <tml-anchor
        text="Click here"
        href="/my-products/"
      />
      to view your products and find out why it was not approved.
    </p>
  </div>
</template>

<script>
export default {
  name: 'HelpApprovalForm',
};
</script>

<style lang="scss" scoped>
p {
  margin-top: 1em;
  margin-bottom: 1em;
}
</style>
